module.exports = __webpack_public_path__ + "img/bird_4.8947eb42.png";